import * as React from 'react';
import { convertIcon } from '../components/Icon';
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm7.9 4.05a1 1 0 0 0-1.8 0l-5 10a1 1 0 1 0 1.8.9l1.22-2.45h5.76l1.23 2.45a1 1 0 0 0 1.78-.9l-5-10ZM12 8.74l1.88 3.76h-3.76L12 8.74Z",
    fill: "currentColor"
  }));
}
const IconComponent = convertIcon(SvgComponent, 'mark');
export default IconComponent;